<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <div
      v-if="data"
      :class="{
        'product-page': true,
      }"
    >
      <PlatformHero :data />
      <SectionBuilder
        v-if="data.content"
        v-bind="data.content"
        :class="{
          '-translate-y-36 md:-translate-y-64': true,
        }"
      />
      <CTABanner
        v-if="ctaData"
        :data="ctaData"
        :class="{
          '-mt-36 md:-mt-200px': true,
        }"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import PlatformHero from '~/components/Organisms/Platform/PlatformHero.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import { queryPlatform } from '~/queries/pages/PagePlatform.query';
import type { QueryPlatformResult } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import SectionBuilder from '~/components/Organisms/SectionBuilder/SectionBuilder.vue';

const { getResolvedCTABanner } = useRefsStore();
const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryPlatformResult>(queryPlatform, {
  currentPathname,
});

const ctaData = await getResolvedCTABanner(data.value?.CTABanner?.reference?._ref);

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.subtitle,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'SoftwareApplication',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.subtitle,
      imageRef:
        data.value?.ogImage?.asset?._ref ||
        data.value?.cardImage?.asset?._ref ||
        data.value?.heroImage?.asset?._ref,
      enabled: true,
    },
  ],
});
</script>
